const BASE_URL = 'https://flyinapi.dev-sh.xyz/api';
// const BASE_URL = 'https://flyinapi.netwave-tech.com/api';
export default BASE_URL;